import { useTranslation } from 'react-i18next';

import { Switch } from '@/components/atoms/Switch';

import styles from './WeightDistributionChartToggles.module.scss';

export interface WeightDistributionChartTogglesProps {
    isAnimated: boolean;
    onAnimatedChange: (isAnimated: boolean) => void;
    isAggregated: boolean;
    onAggregatedChange: (isAggregated: boolean) => void;
    disabled: boolean;
}

/** The histogram's two switches: animate transitions, and aggregate the day. */
export default function WeightDistributionChartToggles(props: WeightDistributionChartTogglesProps) {
    const { isAnimated, onAnimatedChange, isAggregated, onAggregatedChange, disabled } = props;
    const { t } = useTranslation();

    return (
        <div className={styles.switchContainer}>
            <Switch
                label={t('cageWeight.distribution.animation')}
                onCheckedChange={() => onAnimatedChange(!isAnimated)}
                checked={isAnimated}
            />
            <Switch
                label={t('cageWeight.distribution.aggregated')}
                onCheckedChange={() => onAggregatedChange(!isAggregated)}
                checked={isAggregated}
                disabled={disabled}
            />
        </div>
    );
}
